import { fixedUi, fixedUiTpl } from '@/i18n/fixedUi';
import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { normalizeTiktokShopTypeSlug } from '@/tiktok-platform/constants/tiktokRoutes';
import { showToast } from '@/utils/toast';

/**
 * 全托合规资质 / 产品合规暂未开放：提示后回到首页。
 * 半托 / 本土不使用本组件。
 */
export default function TiktokFullComplianceComingSoon({ label = '合规资质' }) {
  const { shopType } = useParams();
  const slug = normalizeTiktokShopTypeSlug(shopType) || 'full';

  useEffect(() => {
    showToast(fixedUiTpl('「{0}」当前功能正在开发中', fixedUi(label)), 'info');
  }, [label]);

  return <Navigate to={`/ipe/tiktok/${slug}/home`} replace />;
}
